<template>
  <div class="modal-overlay">
    <div class="modal-content" style="max-width: 70vw">
      <div class="modal-header">
        <h5 class="modal-title">Fluid Balance Tracking</h5>
        <button type="button" class="close" @click="closeModal">&times;</button>
      </div>

      <div v-if="loading" class="modal-body">
        <loader />
      </div>

      <div v-if="!loading" class="modal-body">
        <div class="form-grid">
          <div class="form-group">
            <label>Time Lapsed (min):</label>
            <input v-model="form.minutes_lapsed" type="number" min="0" />
          </div>
          <div class="form-group">
            <label>Ultrafiltration Rate (ml/hr):</label>
            <input v-model="form.uf_rate" type="number" step="0.1" />
          </div>
          <div class="form-group">
            <label>Total Fluid Removed (ml):</label>
            <input v-model="form.total_removed" type="number" step="0.1" />
          </div>
          <div class="form-group">
            <label>Remaining Target Removal (ml):</label>
            <input v-model="form.remaining_removal" type="number" step="0.1" />
          </div>
          <div class="form-group">
            <label>Cumulative Removed (ml):</label>
            <input v-model="form.cumulative_removed" type="number" step="0.1" />
          </div>
        </div>
      </div>

      <div v-if="!loading" class="modal-footer">
        <button type="button" class="btn-secondary" @click="closeModal">
          Cancel
        </button>
        <button type="button" class="btn-primary" @click="saveLog">Save</button>
      </div>
    </div>
  </div>
</template>

<script>
import loader from "./loader.vue";
import { generalApiRequest } from "../../../api/apiIndex";
import getElapsedMinutes from "./lapsed_minutes";
export default {
  name: "FluidBalanceModal",
  data() {
    return {
      loading: false,
      form: {
        session_id: "",
        minutes_lapsed: "",
        uf_rate: "",
        total_removed: "",
        remaining_removal: "",
        cumulative_removed: "",
      },
    };
  },
  props: {
    session_id: {
      type: [Number, String],
      required: true,
    },
    start_time: {
      type: String,
      required: true,
    },
  },
  components: {
    loader,
  },
  methods: {
    closeModal() {
      this.$emit("close-fluid-balance-modal");
    },
    async getElapsedMinutes() {
      this.loading = true;
      const minutes = await getElapsedMinutes(this.session_id);
      this.form.minutes_lapsed = minutes;
      this.loading = false;
      return minutes;
    },
    async saveLog() {
      this.loading = true;
      this.form.session_id = this.session_id;
      // this.$emit("save-log", this.form);
      const req = await generalApiRequest(
        `fluid-balance`,
        "POST",
        this.form,
        1
      );

      console.log(req);
      this.closeModal();
      this.loading = false;
    },
  },
  mounted() {
    this.getElapsedMinutes();
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(31, 31, 31, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-content {
  background: white;
  padding: 1.5rem;
  border-radius: 0.5rem;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.modal-title {
  font-size: 1.2rem;
  font-weight: 600;
}

.close {
  background: #e31919;
  border: none;
  color: white;
  font-size: 1.5rem;
  line-height: 1;
  padding: 0.4rem 0.7rem;
  cursor: pointer;
  border-radius: 0.3rem;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 0.8rem;
  margin-bottom: 1rem;
}

.form-group label {
  font-weight: 600;
  display: block;
  margin-bottom: 0.2rem;
}

.form-group input {
  width: 100%;
  padding: 0.45rem;
  border: 1px solid #ccc;
  border-radius: 0.3rem;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.7rem;
  padding-top: 1rem;
  border-top: 1px solid #ddd;
}

.btn-primary {
  background: #2786f7;
  color: white;
  padding: 0.45rem 0.9rem;
  border: none;
  border-radius: 0.3rem;
  cursor: pointer;
}

.btn-secondary {
  background: #bbb;
  color: white;
  padding: 0.45rem 0.9rem;
  border: none;
  border-radius: 0.3rem;
  cursor: pointer;
}
</style>
